export const PublicRoutes = {
  LOGIN: "/",
  FORGOT: "/forgot-password",
  SETPASSWORD: "/reestablecer/:auth",
};

export const PrivateRoutes = {
  PRIVATE: "/private",
  MAIN: "/main",
  DASHBOARD: "/dashboard",
  PRE_OCUPACIONAL: "/programacion-antecedentes",
  PERIODICO: "/programacion-periodico",
  RETIRO: "/programacion-retiro",
  VISITA: "/programacion-visita",
  REINCORPORACION: "/programacion-reincorporacion",
  PROGRAMACION: "/programacion",
  NO_ASISTIDA: "/programacion-noasistidas",

  CONTROL_PREOCUPACIONAL: "/control-preocupacional",
  CONTROL_PERIODICO: "/control-periodico",
  CONTROL_RETIRO: "/control-retiro",
  CONTROL_ASISTENCIA: "/control-asistencia",
  CONTROL_CONSOLIDADO: "/control-consolidado",

  MASTER_CLINICA: "/clinica",
  MASTER_TIPO_EXAMEN: "/tipoExamen",
  MASTER_TIPO_RESULTADO: "/tipoResultado",
  MASTER_TIPO_CERTIFICADO: "/tipoCertificado",
  MASTER_USUARIO: "/usuario",
  MASTER_USUARIO_NUEVO: "/usuario-nuevo",
  MASTER_EMAIL: "/email",
  MASTER_CENTRO_COSTO: "/centroCosto",
};
